module.exports = __webpack_public_path__ + "static/media/beaconManageTeamHeader.720db700.jpg";